import React from 'react';
import PropTypes from 'prop-types';
import { AssetPropType } from '@mulesoft/exchange-react-shapes';
import config from 'config';
import Callout from '@mulesoft/exchange-ui-components/lib/components/Callout';
import {
  ConfigContext,
  ErrorHandlingContext,
  UserContext
} from '@mulesoft/exchange-react-hooks';
import { format } from 'url';
import { fetch } from '~/utils/fetch';
import styles from './OAS3SupportInfo.css';

const OAS3SupportInfo = ({
  asset,
  isShowOAS3SupportInfoEnabled,
  isEdit,
  onFetchEnd
}) => {
  const [hasFetchedFeatures, setFetchedFeatures] = React.useState(false);
  const [isUsingUnsupportedFeatures, setUnsupportedFeatures] =
    React.useState(false);
  const { featureFlags } = React.useContext(ConfigContext);
  const { context } = React.useContext(UserContext);
  const handleError = React.useContext(ErrorHandlingContext);
  const isOAS3Phase2Enabled = featureFlags['oas-3-phase-2-enabled'];

  async function fetchAssetSupport() {
    const url = format({
      pathname: `/exchange/api/v2/assets/${asset.groupId}/${asset.assetId}/${asset.version}/api/query/platformSupport`
    });

    try {
      const response = await fetch(url, {
        context
      });
      const result = await response.json();

      if (result) {
        setUnsupportedFeatures(result.isUsingUnsupportedFeatures);
      }

      // Function used for testing if Callout is rendered
      onFetchEnd();
    } catch (error) {
      handleError(error, fetchAssetSupport);
    }
  }

  const isOAS3Asset =
    asset.originalFormat === 'oas' && asset.originalFormatVersion === '3.0';

  React.useEffect(() => {
    if (!hasFetchedFeatures && isOAS3Phase2Enabled && isOAS3Asset) {
      fetchAssetSupport();
      setFetchedFeatures(true);
    }
  });

  if (
    !isShowOAS3SupportInfoEnabled ||
    !isOAS3Asset ||
    isEdit ||
    (isOAS3Phase2Enabled && !isUsingUnsupportedFeatures)
  ) {
    return null;
  }

  if (isOAS3Phase2Enabled) {
    return (
      <Callout
        className={styles.oas3SupportMessage}
        testId="oas-3-support-warning"
        type="info"
      >
        This OAS 3.0 specification contains features (including callbacks) that
        are not yet supported on Anypoint Platform.{' '}
        <a
          key="oas-3-support-link"
          href={config.docsLinks.oas3SupportLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn more.
        </a>
      </Callout>
    );
  }

  return (
    <Callout
      className={styles.oas3SupportMessage}
      testId="oas-3-support-warning"
      type="info"
    >
      Support for OAS 3.0 on the Anypoint Platform is limited.{' '}
      <a
        key="oas-3-support-link"
        href={config.docsLinks.oas3SupportLink}
        target="_blank"
        rel="noopener noreferrer"
      >
        See what is currently supported.
      </a>
    </Callout>
  );
};

OAS3SupportInfo.propTypes = {
  asset: AssetPropType,
  isShowOAS3SupportInfoEnabled: PropTypes.bool,
  isEdit: PropTypes.bool,
  onFetchEnd: PropTypes.func
};

OAS3SupportInfo.defaultProps = {
  isShowOAS3SupportInfoEnabled: true,
  onFetchEnd: () => {},
  isEdit: false
};
export default OAS3SupportInfo;
